// polyfill.
// 実装が2022年前半と比較的新しめのため
import structuredClone from '@ungap/structured-clone'

export default defineNuxtPlugin(() => {
  if (!('structuredClone' in globalThis)) {
    globalThis.structuredClone = structuredClone
  }
})
